import { render, staticRenderFns } from "./closure.vue?vue&type=template&id=aebd24ac"
import script from "./closure.vue?vue&type=script&lang=js"
export * from "./closure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aebd24ac')) {
      api.createRecord('aebd24ac', component.options)
    } else {
      api.reload('aebd24ac', component.options)
    }
    module.hot.accept("./closure.vue?vue&type=template&id=aebd24ac", function () {
      api.rerender('aebd24ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/brand/overview/closure.vue"
export default component.exports